import { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import { clearFields, getFormValues } from 'redux-form';

import ManageUserComponent from './ManageUserComponent';

import { onModalClose } from '../Modal/actions';
import { managePersonCredentials } from './actions';

import {
  findPersonEmail,
  findPersonPhoneNumber,
  onManageUserValidate,
} from './utils';

const form = 'ManageUser';

const ManageUserContainer = (props) => {
  const {
    formValues,
    onActionTypeChange,
    onManagePersonCredentials,
    onCredentialsUpdate,
    onModalClose,
    initialValues,
    person,
  } = props;
  const actionType = formValues?.action;

  useEffect(() => {
    actionType && onActionTypeChange();
  }, [actionType]);

  const validate = (values) => onManageUserValidate(values);
  const onSubmit = async (values) => {
    const res = await onManagePersonCredentials(values);
    if (!res) return;
    onModalClose();
    onCredentialsUpdate();
  };

  return (
    <ManageUserComponent
      form={form}
      validate={validate}
      actionType={actionType}
      onSubmit={onSubmit}
      initialValues={initialValues}
      person={person}
    />
  );
};
ManageUserContainer.defaultProps = {
  formValues: {},
  initialValues: {},
};
ManageUserContainer.propTypes = {
  formValues: PropTypes.instanceOf(Object),
  initialValues: PropTypes.instanceOf(Object),
  onActionTypeChange: PropTypes.func.isRequired,
  onManagePersonCredentials: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired,
  onCredentialsUpdate: PropTypes.func.isRequired, // refetch person data
  person: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const formValues = getFormValues(form)(state);
  const email = findPersonEmail(ownProps?.person);
  const phoneNumber = findPersonPhoneNumber(ownProps?.person);
  const initialValues = {
    email,
    phoneNumber,
  };
  return {
    initialValues,
    formValues,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onModalClose: () => onModalClose(dispatch),
  onActionTypeChange: () =>
    dispatch(
      clearFields(
        form,
        true,
        true,
        'email',
        'phoneNumber',
        'password',
        'confirmPassword',
      ),
    ),
  onManagePersonCredentials: (data) =>
    managePersonCredentials(dispatch, ownProps?.personId, data),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManageUserContainer);
